module.exports = __webpack_public_path__ + "static/media/image-banner-minhas-viagens.188baf33.jpg";